import XAPPService from "app/Core/services/XAPPService";
export const TABELAHORAS_INFO = '[TABELAHORAS APP] TABELAHORAS INFO';
export const TABELAHORAS_GET_JORNADA = '[TABELAHORAS APP] TABELAHORAS GET JORNADA';
export const TABELAHORAS_WARNING = '[TABELAHORAS APP] TABELAHORAS WARNING';
export const TABELAHORAS_ERROR = '[TABELAHORAS APP] TABELAHORAS ERROR';

const GetFormUsuarioState = [
    'idpessoaformulario',
    'jornada'
];

export function getJornada(_AValue, _AParams) {
    return (dispatch) => {

        var AConditionsAND = [{ Campo: "pessoaformulario.formulario->>''uid''", Operador: "=", Valor: _AValue }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "FormularioJornada", AActions, "spvwempresapessoafuncionario", GetFormUsuarioState, "SELECIONAR", AConditionsAND, AConditionsOR)

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: TABELAHORAS_GET_JORNADA,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: TABELAHORAS_ERROR,
                    payload: error
                });
            });
    };
}
